import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

import {
  isShapeFrozenForGeometry,
  isShapeLockedForUserEdit,
} from '@/lib/groups/element-edit-policy'

export function shapesByIdFromManager(
  mgr: ShapeManagerRef | null | undefined
): Map<string, ShapeData> {
  const list = mgr?.getShapes() ?? []

  return new Map(list.map((s) => [s.id, s]))
}

/** Geometry mutations must not run when the shape is locked or frozen (incl. ancestors). */
export function isPanelShapeGeometryBlocked(
  shape: ShapeData,
  shapesById: Map<string, ShapeData>
): boolean {
  return isShapeLockedForUserEdit(shape, shapesById) || isShapeFrozenForGeometry(shape, shapesById)
}

/** True when any selected shape cannot receive geometry edits (lock or freeze, incl. ancestors). */
export function selectionHasGeometryBlocked(
  shapes: ShapeData[],
  shapesById: Map<string, ShapeData>
): boolean {
  return shapes.some((shape) => isPanelShapeGeometryBlocked(shape, shapesById))
}

/** True when no selected object can receive geometry edits from the panel. */
export function selectionAllGeometryBlocked(
  shapes: ShapeData[],
  shapesById: Map<string, ShapeData>
): boolean {
  if (shapes.length === 0) return true

  return shapes.every((shape) => isPanelShapeGeometryBlocked(shape, shapesById))
}

export function selectionHasLocked(
  shapes: ShapeData[],
  shapesById: Map<string, ShapeData>
): boolean {
  return shapes.some((shape) => isShapeLockedForUserEdit(shape, shapesById))
}
